export default {
  title: 'Tilføj fil: {{slot}}',
  replace_title: 'Udskift fil: {{slot}}',
  replace_description: 'Den nye fil erstatter denne. Vi beholder den gamle i vores arkiv.',
  form: {
    kind: {
      label: 'Type af ID',
      options: {
        passport: 'Pas',
        driver_license: 'Kørekort',
        id_card: 'ID-kort',
        residence_permit: 'Opholdstilladelse',
      },
    },
    front: {
      label: 'Forside',
    },
    back: {
      label: 'Bagside',
    },
    file: {
      label: 'Fil',
    },
    expires_at: {
      label: 'Gyldig til',
      placeholder: 'Vælg en dato',
    },
    holder: {
      label: 'Hvis ID er dette?',
      options: {
        owner: 'Mit, ejerens',
        partner: 'En partners',
      },
    },
    holder_name: {
      label: 'Partners navn',
      placeholder: 'Fornavn og efternavn',
    },
  },
  accepted_files: 'PDF, JPG eller PNG, op til {{max}} MB.',
  accepted_images_min: 'Et foto skal være mindst {{min}} KB.',
  errors: {
    file_type: 'Kun PDF-, JPG- eller PNG-filer accepteres.',
    file_too_large: 'Filen er større end {{max}} MB.',
    file_too_small: 'Et foto skal være mindst {{min}} KB.',
  },
  buttons: {
    select_file: 'Vælg fil',
    submit: 'Upload',
    cancel: 'Annuller',
  },
  toasts: {
    success: 'Fil uploadet',
    error: 'Filen kunne ikke uploades.',
  },
};
